// Libraries
import styled from 'styled-components';

export const CardContainer = styled.div`
  z-index: 1;
`;
